import { motion } from 'framer-motion';

export function SidebarSkeleton() {
  return (
    <div className="flex-col w-[280px] h-full bg-dualite-background-primary border-r border-dualite-border-primary text-sm relative z-sidebar hidden md:flex">
      <div className="flex-1 flex flex-col h-full w-full overflow-hidden">
        {/* Header Section */}
        <div className="bg-dualite-background-primary pt-6 px-4">
          <div className="flex items-center justify-between mb-8">
            <div className="flex items-center gap-3">
              <div style={{ background: 'linear-gradient(180deg, #131314 0%, #1D1D1F 100%)' }} className="w-10 h-10 rounded-xl flex items-center justify-center border border-dualite-border-primary shadow-lg">
                <img src="/images/dualite-logo.svg" alt="Dualite" className="w-6 h-6 brightness-0 invert" />
              </div>
              <span className="text-xl font-bold text-dualite-text-primary">Dualite</span>
            </div>
            <div className="w-9 h-9 bg-dualite-background-button rounded-lg animate-pulse" />
          </div>

          {/* Action Buttons */}
          <div className="space-y-2 mb-6">
            {/* New Chat Button Skeleton */}
            <div className="w-full h-[46px] bg-dualite-background-tertiary rounded-xl border border-dualite-border-primary flex items-center justify-between px-4">
              <div className="h-4 w-20 bg-dualite-background-button rounded animate-pulse" />
              <div className="flex gap-1">
                <div className="w-5 h-5 bg-dualite-background-button rounded animate-pulse" />
                <div className="w-5 h-5 bg-dualite-background-button rounded animate-pulse" />
              </div>
            </div>

            {/* Search Bar Skeleton */}
            <div className="w-full h-[46px] bg-transparent rounded-xl border border-dualite-border-primary flex items-center px-4 gap-3">
              <div className="w-4.5 h-4.5 bg-dualite-background-button rounded animate-pulse" />
              <div className="h-4 w-16 bg-dualite-background-button/50 rounded animate-pulse" />
              <div className="ml-auto flex gap-1">
                <div className="w-5 h-5 bg-dualite-background-button rounded animate-pulse" />
                <div className="w-5 h-5 bg-dualite-background-button rounded animate-pulse" />
              </div>
            </div>
          </div>
        </div>

        {/* List Items Section */}
        <div className="flex-1 overflow-y-auto min-h-0 pb-5 px-4">
          {[1, 2].map((category) => (
            <div key={category} className="mt-4 first:mt-0">
              {/* Category Header Skeleton */}
              <div className="flex items-center w-full gap-2 py-2 pl-2">
                <div className="h-4 w-20 bg-dualite-background-button rounded animate-pulse" />
                <div className="h-[1px] flex-1 bg-dualite-border-primary" />
                <div className="w-6 h-6 bg-dualite-background-button border border-dualite-border-primary rounded animate-pulse" />
              </div>

              {/* Items Skeleton */}
              <div className="space-y-2 mt-2">
                {[1, 2, 3].map((i) => (
                  <div key={i} className="h-10 w-full bg-dualite-background-button/20 rounded-lg animate-pulse mx-2" />
                ))}
              </div>
            </div>
          ))}
        </div>

        {/* Footer Section */}
        <div className="flex flex-col border-t border-dualite-border-primary bg-dualite-background-primary z-10 p-4 gap-3">
          {/* Usage Card Skeleton */}
          <div className="bg-dualite-background-secondary border border-dualite-border-primary rounded-2xl p-4 space-y-3">
            <div className="h-5 w-24 bg-dualite-background-button rounded animate-pulse" />
            <div className="h-2 w-full bg-dualite-background-button rounded-full overflow-hidden">
              <div className="h-full w-1/4 bg-green-400/30 rounded-full animate-pulse" />
            </div>
            <div className="h-8 w-full bg-dualite-background-button rounded-lg animate-pulse" />
          </div>

          {/* User Profile Skeleton */}
          <div className="flex items-center justify-between w-full">
            <div className="flex items-center gap-3">
              {/* Avatar */}
              <div className="w-10 h-10 rounded-full bg-dualite-background-button animate-pulse" />
              {/* User Info */}
              <div className="flex flex-col gap-1.5">
                <div className="h-3 w-32 bg-dualite-background-button rounded animate-pulse" />
                <div className="h-3 w-16 bg-dualite-background-button/50 rounded animate-pulse" />
              </div>
            </div>
            {/* Settings Icon */}
            <div className="w-9 h-9 bg-dualite-background-button rounded-xl animate-pulse" />
          </div>
        </div>
      </div>
    </div>
  );
}
